// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import MuiAppBar from './MuiAppBar';

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  MuiAppBar,
};
